import { useState, useEffect } from 'react';
import styles from './CategoryCard.module.scss';
import { Badge, Typography } from '@mui/material';
import { Divider, Link } from '../../../../../commons/components/ui';
import LEAF_DARK from '../../../../../src/assets/images/icons/leaf-dark.svg';
import { businessHourTiming } from '../../../../../commons/utils/utils';
import { config } from '../../../../../config';

const CategoryCard = ({
  categoryData = [],
  categoryChange = () => {},
  categoryCardData = {},
}) => {
  const [isOnline, setOnline] = useState(false); // for support
  const [Online, setIsOnline] = useState(false); // for business enqiry

  const contactList = {
    title: '888-488-3112',
    link: 'tel:+1-888-488-3112',
    showOnline: true,
    mail: 'contactus@relieffactor.com',
  };
  useEffect(() => {
    setOnline(
      businessHourTiming(
        config.supportHours.openTime,
        config.supportHours.closeTime
      )
    );
  }, []);

  useEffect(() => {
    setIsOnline(
      businessHourTiming(
        config.businessHours.openTime,
        config.businessHours.closeTime
      )
    );
  }, []);

  return (
    <>
      <div className={styles.container}>
        <div className={styles.categoryContainer}>
          <div className={styles.categoryListContainer}>
            {categoryData.map((category) => (
              <div
                className={styles.categoryListItemContainer}
                key={category.id}
              >
                <Typography
                  variant="h5"
                  color="primary.main"
                  id={category.id}
                  onClick={() =>
                    !category.subcategories && categoryChange(category.id)
                  }
                  ref={category.ref}
                  className={`${
                    category.id == 'faq'
                      ? styles.categoryNameMainActive
                      : styles.categoryName
                  }`}
                >
                  {category.accordionTitle}
                </Typography>
                {category.subcategories && (
                  <div className={styles.subcategoryListContainer}>
                    {category.subcategories.map((subCategory) => (
                      <Typography
                        key={subCategory.id}
                        variant="h5"
                        color="primary.main"
                        id={subCategory.id}
                        ref={subCategory.ref}
                        onClick={() => categoryChange(subCategory.id)}
                        className={`${styles.categoryName} ${styles.subcategoryName}`}
                      >
                        {subCategory.accordionTitle}
                      </Typography>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
          <Divider className={styles.categoryDivider} />
          <div className={styles.contactListContainer}>
            <div className={styles.contactContainer}>
              <Typography
                variant="p3"
                color="primary.main"
                className={styles.contactUsTitle}
              >
                Contact Us
              </Typography>
              <Link href={categoryCardData?.link} underline="none">
                <div className={styles.phoneNumberRow}>
                  <Typography
                    variant="p3"
                    color="primary.black"
                    component="span"
                    className={styles.phoneText}
                  >
                    Service
                  </Typography>
                  <div className={styles.phoneContainer}>
                    <div className={styles.phoneIcon}>
                      {categoryCardData?.icon}
                    </div>
                    <Typography
                      variant="h5"
                      color="primary.main"
                      className={styles.phoneNumberContent}
                    >
                      {categoryCardData?.contactNumber}
                    </Typography>
                  </div>
                  <div className={styles.badgeContainer}>
                    <Badge
                      className={`${
                        isOnline ? styles.onlineStatus : styles.offlineStatus
                      }`}
                      sx={{
                        pr: 1,
                        color: 'warning',
                      }}
                      variant="dot"
                    />
                  </div>
                </div>
              </Link>
              <div className={styles.openTimeRow}>
                <Typography variant="p3" color="primary.black" component="p">
                  {categoryCardData?.timing}
                </Typography>
              </div>
              <Link href={contactList?.link} underline="none">
                <div className={styles.phoneNumberRow}>
                  <Typography
                    variant="p3"
                    color="primary.black"
                    component="span"
                    className={styles.phoneText}
                  >
                    Sales
                  </Typography>
                  <div className={styles.phoneContainer}>
                    <div className={styles.phoneIcon}>
                      {categoryCardData?.icon}
                    </div>
                    <Typography
                      variant="h5"
                      color="primary.main"
                      className={styles.phoneNumberContent}
                    >
                      {contactList?.title}
                    </Typography>
                  </div>

                  <div className={styles.badgeContainer}>
                    <Badge
                      className={`${
                        Online ? styles.onlineStatus : styles.offlineStatus
                      }`}
                      sx={{
                        pr: 1,
                        color: 'warning',
                      }}
                      variant="dot"
                    />
                  </div>
                </div>
              </Link>
              <div className={styles.openTimeRow}>
                <Typography variant="p3" color="primary.black" component="p">
                  {contactList?.timing}
                </Typography>
              </div>
              <div className={styles.mailDiv}>
                <Typography
                  variant="p3"
                  color="primary.black"
                  className={styles.mailContent}
                >
                  <Link href={'/business-inquiry'}>
                    Submit a Business Inquiry
                  </Link>
                </Typography>
              </div>
            </div>
            <div className={styles.iconContainer}>
              <LEAF_DARK />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CategoryCard;
